import { Button, Layout, Select, TablePaginationConfig } from "antd";
import { Content } from "antd/lib/layout/layout";
import Sider from "antd/lib/layout/Sider";
import React, { useEffect, useMemo, useState } from "react";
import styles from "./SupplierList.module.css";
import { useHistory, useLocation, useRouteMatch } from "react-router";
import useLoading from "../../hooks/useLoading";
import { useUserContext } from "../../Context/UserContext";
import { CheckAutoReport } from "../../Services/AppSettingService";
import { GetAllDynamic } from "../../Services/DynamicService";
import {
  CheckRolePermission,
  CheckRolePermissionById,
} from "../../Services/AuthorizedService";
import { GetTemplateeBindFormNameDDL } from "../../Services/TemplateService";
import {
  DeleteReport,
  ReportTemplateSelectByReportID,
} from "../../Services/ReportService";
import { FilterOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { confirmDialog } from "primereact/confirmdialog";
import { SplitButton } from "primereact/splitbutton";
import DynamicTableRedCross from "../../components/RedcrossComponents/DynamicTableRedCross";
import {
  GetAllSupplierList,
  SendRequestQuotation,
} from "../../Services/e-pro/SupplierService";
import {
  RequestQuotationBody,
  SupplierData,
} from "../../Services/e-pro/models/SupplierModel";
import RequestOfferDialog, { RequestQuationForm } from "./RequestOfferDialog";
import { Http2ServerResponse } from "http2";
import useAlert from "../../hooks/useAlert";

const SupplierList = () => {
  const location = useLocation();
  const apiName = "DynamicReport".replace("/", "");
  const [text, setText] = useState<string>("");
  const [itemsCount, setItemsCount] = useState<number>(0);
  const [supplierList, setSupplierList] = useState<SupplierData[]>();
  const [tableData, setTableData] = useState<any[]>([]);
  const [supplierColumns, setSupplierColumns] = useState<any[]>();
  const [visibleDialog, setVisibleDialog] = useState<boolean>(false);
  const [template, setTemplate] = useState<any>([]);
  const { isLoad, setLoad } = useLoading();
  const [editReport, setEditReport] = useState<any>(false);
  const [checkReport, setCheckReport] = useState<any>(false);
  const [dataEditReport, setDataEditReport] = useState<any>([]);
  const [userData] = useUserContext();
  const [emp_data, setEmp_data] = useState<any>();
  const [_baseUrl, setbaseUrl] = useState<string>();
  const [isAdmin, setIsAdmin] = useState<boolean>();
  const { search } = useLocation();
  const query = useMemo(() => new URLSearchParams(search), [search]);
  const [isAutoReport, setIsAutoReport] = useState<boolean>(false);
  const [canEdit, setCanEdit] = useState<boolean>(false);
  const { url } = useRouteMatch();
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [openOfferDialog, setOpenOfferDialog] = useState<boolean>(false);
  const { toggleAlert } = useAlert();
  let history = useHistory();

  const [paginationOption, setPaginationOption] =
    useState<TablePaginationConfig>({
      position: ["bottomLeft"],
      size: "small",
      current: 1,
      showSizeChanger: true,
      onChange: (page, pageSize) => {
        let _page: TablePaginationConfig = paginationOption;
        _page.current = page;
        _page.pageSize = pageSize;

        setPaginationOption(_page);
      },
    });

  useEffect(() => {
    setLoad(true);
    const path = apiName.split("/");
    if (path[2]) {
      history.push(
        `${url}/${path[1].replaceAll("/", "\\")}/${path[2]}/${isAutoReport}`
      );
    } else {
      checkAutoReport();
    }
  }, []);

  useEffect(() => {
    setLoad(true);

    fetchTemplate();
  }, [isAutoReport]);

  useEffect(() => {
    fetchReport();
  }, []);

  const checkAutoReport = async () => {
    const mode = query.get("mode");
    const isEnable = await CheckAutoReport();
    if (mode === "test") {
      setIsAutoReport(!isEnable);
    } else {
      setIsAutoReport(isEnable);
    }
  };
  const transformKeys = (data: any[], keyMap: { [name: string]: string }) => {
    return data.map((item) => {
      let newItem: { [key: string]: any } = {};
      Object.keys(item).forEach((key) => {
        const newKey = keyMap[key] || key;
        newItem[newKey] = item[key];
      });
      return newItem;
    });
  };
  async function fetchReport() {
    try {
      let empList: any[] = [];
      let _emp_dataFind: any = undefined;
      const userId = query.get("usrid")
        ? () => {
            setIsAdmin(false);
            return query.get("usrid");
          }
        : userData.EmployeeId;

      let _dataDynamic = await GetAllSupplierList();

      const { _isAdmin, isOk } = await CheckRolePermissionById(
        _emp_dataFind ? _emp_dataFind?.EmployeeId : userData.EmployeeId,
        [1, 2]
      );

      if (query.get("usrid") && _isAdmin) {
        _emp_dataFind = empList.find(
          (item: any) => item.EmployeeId === Number(query.get("usrid"))
        );
      }

      if (supplierList === undefined) {
        setSupplierList(_dataDynamic.data);
      }

      let mapValueToKey: { [name: string]: string } = {
        SellerType: "ประเภทผู้ค้า",
        SellerName: "ชื่อผู้ค้า",
        BussniesType: "ประเภทกิจการ",
        ServiceItems:"ประเภทสินค้า/บริการ",
        CreatedDate: "วันที่สร้าง",
        Address: "ที่อยู่",
        ContactName: "ชื่อผู้ติดต่อ",
        PhoneNumber: "หมายเลขโทรศัพท์",
        Email: "อีเมลล์",
      };

      const transformedData = transformKeys(_dataDynamic.data, mapValueToKey);
      setCanEdit(isOk);
      setIsAdmin(_isAdmin);
      setTableData([...transformedData]);
      setSupplierColumns(undefined);
      setText("Report List");
      setLoad(false);
    } catch (error) {
      console.log("report=>error", error);
      setLoad(false);
    }
  }

  async function fetchTemplate() {
    const empid = userData.EmployeeId;
    const DepartmentId = userData.DepartmentId;

    const dataJsonn = {
      CreatedBy: empid.toString(),
      DepartmentId: DepartmentId,
      Username: userData.Username,
      Email: userData.Email,
    };

    let _dataTemplatee = await GetTemplateeBindFormNameDDL(dataJsonn);

    setTemplate(_dataTemplatee);
  }

  async function fetchGetReportById(rePortId: any) {
    let _ReportById = await ReportTemplateSelectByReportID(rePortId);
    setDataEditReport(_ReportById);
  }

  const actionBodyTemplate = (record: any) => {
    const adminActionBody = [
      {
        label: "Edit",
        icon: "pi pi-pencil",
        command: () => {
          fetchGetReportById(record.ReportTemplateId);
          setVisibleDialog(true);
          setCheckReport(true);
          setEditReport(true);
        },
      },
      {
        label: "Delete",
        icon: "pi pi-trash",
        command: () => {
          confirmDialog({
            message: "Do you want to delete this report.",
            header: "Delete",
            icon: "p-confirm-dialog-icon pi pi-info-circle",
            rejectClassName: "hide",
            acceptClassName:
              "p-button p-component p-confirm-dialog-accept table-accept p-button-danger table-control-confirm-button p-button-accept-cancel",
            accept: async () => {
              const res = await DeleteReport(record.ReportTemplateId);
              if (res) {
                setLoad(true);
                fetchReport();
              }
            },
          });
        },
      },
    ];
    let _user: any = userData;
    if (query.get("usrId")) {
      _user = emp_data.find((e: any) => e.EmployeeId == query.get("usrId"));
    }

    if (isAdmin && !query.get("usrId")) {
      return (
        <React.Fragment>
          <SplitButton
            // id
            className="p-button-secondary"
            model={adminActionBody}
            dropdownIcon="pi pi-ellipsis-v"
          />
        </React.Fragment>
      );
    } else if (
      record.CreatedBy === _user.NameTh ||
      record.CreatedBy === _user.NameEn
    ) {
      return (
        <React.Fragment>
          <SplitButton
            className="p-button-secondary"
            model={adminActionBody}
            dropdownIcon="pi pi-ellipsis-v"
          />
        </React.Fragment>
      );
    }
  };

  const onSendRequestQuotion = async (formData: RequestQuationForm) => {
    let _formData: RequestQuotationBody = {
      ...(formData as any),
      SellerID: selectedRows,
      Username: userData.Username,
    };
    _formData.ItemPic = _formData.ItemPic?.fileList?.map(
      (e: any) => e.thumbUrl
    );
    _formData.DateOfRequestment = formData.DateOfRequestment.toISOString();
    _formData.EndOfQuotationDate = formData.EndOfQuotationDate.toISOString();

    const res = await SendRequestQuotation(_formData);
    if (res.code === "200") {
      setOpenOfferDialog(false);
    } else {
      toggleAlert({
        type: "error",
        message: "Error",
        description: res.message,
      });
    }
  };

  function toggleDialog() {
    setVisibleDialog(!visibleDialog);
    fetchReport();
    setEditReport(false);
  }

  if (isLoad) {
    return <></>;
  } else {
    return (
      <Layout>
        <Content className={styles.contents}>
          <div className={styles.content_header}>
            <p className={`${styles.p_tag} ${styles.header}`}>ข้อมูลผู้ค้า</p>
            <Button
              className={styles.send_button}
              size="large"
              disabled={selectedRows.length == 0}
              onClick={() => {
                setOpenOfferDialog(true);
              }}
            >
              ส่งคำขอใบเสนอราคา
            </Button>
          </div>
          <DynamicTableRedCross
            checkBox
            tableName={text}
            dataSource={tableData}
            customColumns={supplierColumns}
            setItemsCount={setItemsCount}
            actionBodyTemplate={actionBodyTemplate}
            paginationOption={paginationOption}
            rowClickAction={(record: any, rowIndex: any, event: any) => {
              window.open(
                `/SupplierDetail?SellerID=${record["SellerID"]}`,
                "_blank"
              );
            }}
            canEdit={canEdit}
            canExport={false}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            dataKey="SellerID"
          />
        </Content>
        <RequestOfferDialog
          visible={openOfferDialog}
          onCancel={() => {
            setOpenOfferDialog(false);
          }}
          onSubmit={onSendRequestQuotion}
        />
      </Layout>
    );
  }
};

export default SupplierList;
